import { Policy } from 'ag-common-lib/lib/models/utils/policy.model';

export enum RegisterUserKeys {
  firstName = 'firstName',
  lastName = 'lastName',
  mobileNumber = 'mobileNumber',
  upline = 'upline',
  email = 'email',
  password = 'password',
  userAgreementConfirmation = 'userAgreementConfirmation',
  policies = 'policies',
}

export interface RegisterUser {
  [RegisterUserKeys.firstName]: string;
  [RegisterUserKeys.lastName]: string;
  [RegisterUserKeys.mobileNumber]: string;
  [RegisterUserKeys.upline]: string;
  [RegisterUserKeys.email]: string;
  [RegisterUserKeys.password]: string;
  [RegisterUserKeys.userAgreementConfirmation]: boolean;
  [RegisterUserKeys.policies]: Partial<Policy>[];
}
